export default __webpack_public_path__ + "assets/img/capacity_arrow.92d9d82e0f29ac05a1fd74af5380d6f1.png";